export enum VehicleEnginePowerType {
    UNSPECIFIED = 'unspecified',
    PETROL = 'petrol',
    DIESEL = 'diesel',
    FUEL_OIL = 'fuel-oil',
    ELECTRICITY = 'electricity',
    HYDROGEN = 'hydrogen',
    GAS = 'gas',
    METHANOL = 'methanol',
    BIODIESEL = 'biodiesel',
    LPG = 'lpg',
    CNG = 'cng',
}
